module.exports = __webpack_public_path__ + "static/media/ceo-01.6b864f1d.png";